import { render, staticRenderFns } from "./EditDrug.vue?vue&type=template&id=6ebaeae3&scoped=true&lang=pug&"
import script from "./EditDrug.vue?vue&type=script&lang=ts&"
export * from "./EditDrug.vue?vue&type=script&lang=ts&"
import style0 from "./EditDrug.vue?vue&type=style&index=0&id=6ebaeae3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebaeae3",
  null
  
)

export default component.exports